import { useNavigate, useParams } from "react-router-dom";
import { useChallengeDetails } from "../../api/challenges/queryHooks";
import { FiInfo } from "react-icons/fi";
import useChallengeUIStore from "./store/challengeUIStore";
import Topbanner from "../../components/topbanner";
import { decodeId } from "../../api/utils";
import { GoHome } from "react-icons/go";
import ROUTES from "../../router/routes";

const Header = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading } = useChallengeDetails(id);
  const navigate = useNavigate();
  const setShowDetails = useChallengeUIStore((state) => state.setShowDetails);

  return (
    <>
      <Topbanner />
      <div className="p-5 bg-[#111111] shadow-xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[14px]">
            <span className="cursor-pointer" onClick={() => navigate(ROUTES.INDEX)}>
              <GoHome className="text-2xl" />
            </span>
            {isLoading ? (
              <span className="text-lg min-w-[200px] h-7 skeleton"></span>
            ) : (
              <span className="text-lg">{data?.data?.title}</span>
            )}
          </div>
          {isLoading ? null : (
            <div className="lg:hidden">
              <button
                onClick={() => setShowDetails(true)}
                className="flex items-center gap-[5px]"
              >
                <FiInfo className="w-4 h-4" />
                <span className="text-xs">Info</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
